import React from 'react';
import { Link } from 'react-router-dom';
import { CloudUpload, FolderOpen } from '@mui/icons-material';
import { Button, Typography, Box, Stack } from '@mui/material';
import '../styles/styles.css';

const Dashboard = () => {
  return (
    <Box sx={{
      minHeight: '100svh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #f8f9fe 0%, #ffffff 60%, #f0eeff 100%)',
      textAlign: 'center',
      padding: '80px 24px 24px',
      boxSizing: 'border-box',
      userSelect: 'none',
      overflow: 'hidden',
    }}>
      <Box sx={{ maxWidth: 640, width: '100%' }}>
        <Typography sx={{
          fontSize: { xs: '0.7rem', sm: '0.85rem' },
          fontWeight: 700,
          letterSpacing: '0.2em',
          color: '#bbb',
          textTransform: 'uppercase',
          mb: 1,
        }}>
          Welcome to
        </Typography>

        <Typography sx={{
          fontSize: { xs: '4.5rem', sm: '6rem' },
          fontWeight: 900,
          color: '#6C63FF',
          fontFamily: 'Poppins, sans-serif',
          letterSpacing: '-0.03em',
          lineHeight: 1,
          mb: { xs: 1.5, sm: 2 },
        }}>
          Storify
        </Typography>

        <Typography sx={{
          color: '#718096',
          mb: { xs: 4, sm: 5 },
          lineHeight: 1.5,
          fontSize: { xs: '1rem', sm: '1.1rem' },
          fontWeight: 500,
          letterSpacing: '0.01em',
          maxWidth: { xs: '260px', sm: '100%' },
          mx: 'auto',
        }}>
          Upload. Download. Share. Anywhere.
        </Typography>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
          <Link to="/upload" style={{ textDecoration: 'none' }}>
            <Button variant="contained" startIcon={<CloudUpload />} sx={{
              backgroundColor: '#6C63FF',
              borderRadius: '14px',
              textTransform: 'none',
              fontWeight: 600,
              px: { xs: 4, sm: 3.5 },
              py: { xs: 1.6, sm: 1.5 },
              fontSize: { xs: '1.05rem', sm: '1rem' },
              boxShadow: 'none',
              width: { xs: '100%', sm: 'auto' },
              '&:hover': { backgroundColor: '#4B45B3', boxShadow: '0 4px 16px rgba(108,99,255,0.3)' },
            }}>
              Upload File
            </Button>
          </Link>

          <Link to="/files" style={{ textDecoration: 'none' }}>
            <Button variant="outlined" startIcon={<FolderOpen />} sx={{
              borderColor: 'rgba(108,99,255,0.4)',
              color: '#6C63FF',
              borderRadius: '14px',
              textTransform: 'none',
              fontWeight: 600,
              px: { xs: 4, sm: 3.5 },
              py: { xs: 1.6, sm: 1.5 },
              fontSize: { xs: '1.05rem', sm: '1rem' },
              width: { xs: '100%', sm: 'auto' },
              '&:hover': { backgroundColor: 'rgba(108,99,255,0.06)', borderColor: '#6C63FF' },
            }}>
              View Files
            </Button>
          </Link>
        </Stack>
      </Box>
    </Box>
  );
};

export default Dashboard;